import { useCallback } from 'react';
import { Box, Typography, Button } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { Navigate } from 'react-router';
import { useAuth } from '@/core/auth/useAuth';
import CircuitBoard from './CircuitBoard';

export default function LoginPage() {
  const { t } = useTranslation();
  const { account, loading, login } = useAuth();

  const getCanvas = () => document.querySelector('canvas[data-circuit]');
  const handleEnter = useCallback(() => { getCanvas()?.dispatchEvent(new Event('circuit-beam-enter')); }, []);
  const handleLeave = useCallback(() => { getCanvas()?.dispatchEvent(new Event('circuit-beam-leave')); }, []);

  if (loading) return null;
  if (account) return <Navigate to="/" replace />;

  return (
    <Box sx={{ display: 'flex', height: '100vh' }}>
      {/* Left — Altyor factory photo (70%) */}
      <Box
        sx={{
          flex: 6,
          display: { xs: 'none', md: 'block' },
          backgroundImage: 'url(/images/login-bg.webp)',
          backgroundSize: 'cover',
          backgroundPosition: 'center',
        }}
      />
      {/* Right — circuit board with centered chip containing form (30%) */}
      <Box
        sx={{
          flex: 4,
          position: 'relative',
          display: 'flex',
          flexDirection: 'column',
          justifyContent: 'center',
          alignItems: 'center',
          overflow: 'hidden',
        }}
      >
        <CircuitBoard />

        {/* Form — sits inside the white central chip area */}
        <Box
          sx={{
            position: 'relative',
            zIndex: 1,
            display: 'flex',
            flexDirection: 'column',
            alignItems: 'center',
            px: { xs: 2, sm: 3, md: 5 },
            maxWidth: { xs: 280, sm: 360 },
          }}
        >
          <Box
            component="img"
            src="/images/altyor-logo.svg"
            alt="Altyor"
            sx={{ width: { xs: 110, md: 140 }, mb: { xs: 2.5, md: 4 } }}
          />
          <Typography
            variant="h3"
            sx={{ mb: 3, textAlign: 'center', fontSize: { xs: '18px', md: '22px' }, whiteSpace: 'nowrap' }}
          >
            {t('auth.welcome')}
          </Typography>
          <Button
            variant="contained"
            color="primary"
            size="large"
            onClick={login}
            onMouseEnter={handleEnter}
            onMouseLeave={handleLeave}
            sx={{ px: 5, py: 1.5, fontSize: '15px' }}
          >
            {t('auth.loginCta')}
          </Button>
        </Box>
      </Box>
    </Box>
  );
}
